<template>
  <div class="cron-expression">
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <!-- 秒 -->
      <el-tab-pane label="秒" name="second">
        <el-radio-group v-model="secondType">
          <div class="cron-row"><el-radio label="*">每秒</el-radio></div>
          <div class="cron-row">
            <el-radio label="interval">每隔</el-radio>
            <el-input-number v-model="secondInterval" :min="1" :max="59" size="small" style="width: 100px;margin: 0 5px"></el-input-number>秒
          </div>
          <div class="cron-row">
            <el-radio label="range">从</el-radio>
            <el-input-number v-model="secondRangeStart" :min="0" :max="59" size="small" style="width: 100px;margin: 0 5px"></el-input-number>
            到
            <el-input-number v-model="secondRangeEnd" :min="0" :max="59" size="small" style="width: 100px;margin: 0 5px"></el-input-number>秒
          </div>
        </el-radio-group>
      </el-tab-pane>

      <!-- 分钟 -->
      <el-tab-pane label="分钟" name="minute">
        <el-radio-group v-model="minuteType">
          <div class="cron-row"><el-radio label="*">每分钟</el-radio></div>
          <div class="cron-row">
            <el-radio label="interval">每隔</el-radio>
            <el-input-number v-model="minuteInterval" :min="1" :max="59" size="small" style="width: 100px;margin: 0 5px"></el-input-number>分钟
          </div>
          <div class="cron-row">
            <el-radio label="range">从</el-radio>
            <el-input-number v-model="minuteRangeStart" :min="0" :max="59" size="small" style="width: 100px;margin: 0 5px"></el-input-number>
            到
            <el-input-number v-model="minuteRangeEnd" :min="0" :max="59" size="small" style="width: 100px;margin: 0 5px"></el-input-number>分钟
          </div>
        </el-radio-group>
      </el-tab-pane>

      <!-- 小时 -->
      <el-tab-pane label="小时" name="hour">
        <el-radio-group v-model="hourType">
          <div class="cron-row"><el-radio label="*">每小时</el-radio></div>
          <div class="cron-row">
            <el-radio label="interval">每隔</el-radio>
            <el-input-number v-model="hourInterval" :min="1" :max="23" size="small" style="width: 100px;margin: 0 5px"></el-input-number>小时
          </div>
          <div class="cron-row">
            <el-radio label="range">从</el-radio>
            <el-input-number v-model="hourRangeStart" :min="0" :max="23" size="small" style="width: 100px;margin: 0 5px"></el-input-number>
            到
            <el-input-number v-model="hourRangeEnd" :min="0" :max="23" size="small" style="width: 100px;margin: 0 5px"></el-input-number>小时
          </div>
        </el-radio-group>
      </el-tab-pane>

      <!-- 日 -->
      <el-tab-pane label="日" name="day">
        <el-radio-group v-model="dayType">
          <div class="cron-row"><el-radio label="*">每天</el-radio></div>
          <div class="cron-row">
            <el-radio label="interval">每隔</el-radio>
            <el-input-number v-model="dayInterval" :min="1" :max="31" size="small" style="width: 100px;margin: 0 5px"></el-input-number>天
          </div>
          <div class="cron-row">
            <el-radio label="range">从</el-radio>
            <el-input-number v-model="dayRangeStart" :min="1" :max="31" size="small" style="width: 100px;margin: 0 5px"></el-input-number>
            到
            <el-input-number v-model="dayRangeEnd" :min="1" :max="31" size="small" style="width: 100px;margin: 0 5px"></el-input-number>号
          </div>
          <div class="cron-row"><el-radio label="?">不指定</el-radio></div>
        </el-radio-group>
      </el-tab-pane>

      <!-- 月 -->
      <el-tab-pane label="月" name="month">
        <el-radio-group v-model="monthType">
          <div class="cron-row"><el-radio label="*">每月</el-radio></div>
          <div class="cron-row">
            <el-radio label="interval">每隔</el-radio>
            <el-input-number v-model="monthInterval" :min="1" :max="12" size="small" style="width: 100px;margin: 0 5px"></el-input-number>月
          </div>
          <div class="cron-row">
            <el-radio label="range">从</el-radio>
            <el-input-number v-model="monthRangeStart" :min="1" :max="12" size="small" style="width: 100px;margin: 0 5px"></el-input-number>
            到
            <el-input-number v-model="monthRangeEnd" :min="1" :max="12" size="small" style="width: 100px;margin: 0 5px"></el-input-number>月
          </div>
        </el-radio-group>
      </el-tab-pane>
    </el-tabs>

    <div class="cron-result">
      <el-input v-model="cronExpression" readonly>
        <template slot="prepend">Cron表达式</template>
      </el-input>
      <div style="margin-top: 10px; text-align: right">
        <el-button type="primary" @click="confirm">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CronExpression',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeTab: 'second',
      secondType: '*',
      secondInterval: 5,
      secondRangeStart: 0,
      secondRangeEnd: 30,
      minuteType: '*',
      minuteInterval: 5,
      minuteRangeStart: 0,
      minuteRangeEnd: 30,
      hourType: '*',
      hourInterval: 1,
      hourRangeStart: 0,
      hourRangeEnd: 12,
      dayType: '*',
      dayInterval: 1,
      dayRangeStart: 1,
      dayRangeEnd: 15,
      monthType: '*',
      monthInterval: 1,
      monthRangeStart: 1,
      monthRangeEnd: 6,
      weekType: '?',
      weekValues: []
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val && val.trim()) {
          this.parseCronExpression(val)
        }
      }
    }
  },
  computed: {
    cronExpression() {
      const second = this.getSecondCron()
      const minute = this.getMinuteCron()
      const hour = this.getHourCron()
      const day = this.getDayCron()
      const month = this.getMonthCron()
      const week = this.getWeekCron()
      return `${second} ${minute} ${hour} ${day} ${month} ${week}`
    }
  },
  methods: {
    handleTabClick() {
      // 步骤1: 先清空所有选项,重置为初始默认值
      this.secondType = '*'
      this.minuteType = '*'
      this.hourType = '*'
      this.dayType = '*'
      this.monthType = '*'

      // 步骤2: 根据当前激活的tab,设置该tab的第一个选项
      // (由于上面已经全部重置为第一项了,这里实际上不需要再设置)
      // 但为了代码清晰,还是显式写出来
      switch (this.activeTab) {
        case 'second':
          this.secondType = '*'  // 每秒
          break
        case 'minute':
          this.minuteType = '*'  // 每分钟
          break
        case 'hour':
          this.hourType = '*'  // 每小时
          break
        case 'day':
          this.dayType = '*'  // 每天
          break
        case 'month':
          this.monthType = '*'  // 每月
          break
      }
      // 步骤3: Vue会自动重新计算cronExpression(computed属性),完成渲染
    },
    getSecondCron() {
      if (this.secondType === '*') {
        // 当选择分钟、小时、天、周、月级别的执行时，秒应该为0
        if (this.activeTab !== 'second') return '0'
        return '*'
      }
      if (this.secondType === 'interval') return `*/${this.secondInterval}`
      if (this.secondType === 'range') return `${this.secondRangeStart}-${this.secondRangeEnd}`
      return '0'
    },
    getMinuteCron() {
      if (this.minuteType === '*') {
        // 当选择小时、天、月级别的执行时，分钟应该为0
        if (this.activeTab === 'hour' || this.activeTab === 'day' || this.activeTab === 'month') return '0'
        return '*'
      }
      if (this.minuteType === 'interval') return `*/${this.minuteInterval}`
      if (this.minuteType === 'range') return `${this.minuteRangeStart}-${this.minuteRangeEnd}`
      return '0'
    },
    getHourCron() {
      if (this.hourType === '*') {
        // 当选择天、月级别的执行时，小时应该为0
        if (this.activeTab === 'day' || this.activeTab === 'month') return '0'
        return '*'
      }
      if (this.hourType === 'interval') return `*/${this.hourInterval}`
      if (this.hourType === 'range') return `${this.hourRangeStart}-${this.hourRangeEnd}`
      return '0'
    },
    getDayCron() {
      // 当在月tab时，日期都应该为1（每月1号）
      if (this.activeTab === 'month') {
        return '1'
      }
      if (this.dayType === '?') return '?'
      if (this.dayType === '*') return '*'
      if (this.dayType === 'interval') return `*/${this.dayInterval}`
      if (this.dayType === 'range') return `${this.dayRangeStart}-${this.dayRangeEnd}`
      return '*'
    },
    getMonthCron() {
      if (this.monthType === '*') return '*'
      if (this.monthType === 'interval') return `*/${this.monthInterval}`
      if (this.monthType === 'range') return `${this.monthRangeStart}-${this.monthRangeEnd}`
      return '*'
    },
    getWeekCron() {
      // 已移除周选项，固定返回 ?
      return '?'
    },
    confirm() {
      this.$emit('input', this.cronExpression)
      this.$emit('change', this.cronExpression)
      this.$emit('close')
    },
    cancel() {
      this.$emit('close')
    },
    // 解析 Cron 表达式
    parseCronExpression(expression) {
      try {
        const parts = expression.trim().split(/\s+/)
        if (parts.length !== 6) {
          console.warn('Cron表达式格式不正确，应为6个部分')
          return
        }

        const [second, minute, hour, day, month, week] = parts

        // 解析秒
        this.parseSecond(second)
        // 解析分钟
        this.parseMinute(minute)
        // 解析小时
        this.parseHour(hour)
        // 解析日
        this.parseDay(day)
        // 解析月
        this.parseMonth(month)
        // 解析周
        this.parseWeek(week)
      } catch (error) {
        console.warn('解析Cron表达式失败:', error)
      }
    },
    parseSecond(val) {
      if (val === '*') {
        this.secondType = '*'
      } else if (val.includes('/')) {
        this.secondType = 'interval'
        const parts = val.split('/')
        this.secondInterval = parseInt(parts[1]) || 5
      } else if (val.includes('-')) {
        this.secondType = 'range'
        const parts = val.split('-')
        this.secondRangeStart = parseInt(parts[0]) || 0
        this.secondRangeEnd = parseInt(parts[1]) || 30
      }
    },
    parseMinute(val) {
      if (val === '*') {
        this.minuteType = '*'
      } else if (val.includes('/')) {
        this.minuteType = 'interval'
        const parts = val.split('/')
        this.minuteInterval = parseInt(parts[1]) || 5
      } else if (val.includes('-')) {
        this.minuteType = 'range'
        const parts = val.split('-')
        this.minuteRangeStart = parseInt(parts[0]) || 0
        this.minuteRangeEnd = parseInt(parts[1]) || 30
      }
    },
    parseHour(val) {
      if (val === '*') {
        this.hourType = '*'
      } else if (val.includes('/')) {
        this.hourType = 'interval'
        const parts = val.split('/')
        this.hourInterval = parseInt(parts[1]) || 1
      } else if (val.includes('-')) {
        this.hourType = 'range'
        const parts = val.split('-')
        this.hourRangeStart = parseInt(parts[0]) || 0
        this.hourRangeEnd = parseInt(parts[1]) || 12
      }
    },
    parseDay(val) {
      if (val === '?') {
        this.dayType = '?'
      } else if (val === '*') {
        this.dayType = '*'
      } else if (val.includes('/')) {
        this.dayType = 'interval'
        const parts = val.split('/')
        this.dayInterval = parseInt(parts[1]) || 1
      } else if (val.includes('-')) {
        this.dayType = 'range'
        const parts = val.split('-')
        this.dayRangeStart = parseInt(parts[0]) || 1
        this.dayRangeEnd = parseInt(parts[1]) || 15
      }
    },
    parseMonth(val) {
      if (val === '*') {
        this.monthType = '*'
      } else if (val.includes('/')) {
        this.monthType = 'interval'
        const parts = val.split('/')
        this.monthInterval = parseInt(parts[1]) || 1
      } else if (val.includes('-')) {
        this.monthType = 'range'
        const parts = val.split('-')
        this.monthRangeStart = parseInt(parts[0]) || 1
        this.monthRangeEnd = parseInt(parts[1]) || 6
      }
    },
    parseWeek(val) {
      if (val === '?') {
        this.weekType = '?'
        this.weekValues = []
      } else if (val.includes(',')) {
        this.weekType = 'specific'
        this.weekValues = val.split(',').map(v => v.trim())
      } else if (val !== '*') {
        this.weekType = 'specific'
        this.weekValues = [val]
      }
    }
  }
}
</script>

<style scoped>
.cron-expression {
  padding: 20px;
}

.cron-row {
  margin: 10px 0;
  line-height: 32px;
}

.cron-result {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #dcdfe6;
}
</style>
